import type { RouteRecordRaw } from 'vue-router';

export const newsRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'news-list',
    component: () => import('src/pages/news/NewsListPage.vue'),
  },
  {
    path: ':newsItemSlug',
    props: (route) => ({
      newsItemSlug: route.params.newsItemSlug,
    }),
    name: 'news-item-detail',
    component: () => import('src/pages/news/NewsItemDetailPage.vue'),
  },
];
